import * as React from "react";
import axios from "axios";

import { Link, useNavigate, useParams } from "react-router-dom";
import {
  RiCalendar2Line,
  RiMoneyDollarCircleLine,
  RiTimeLine,
  RiHomeOfficeLine,
  RiCarLine,
  RiCalculatorLine,
  RiFileEditLine,
} from "react-icons/ri";
import Slider from "@mui/material/Slider";

import Textfield from "../../../Components/Textfield";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal";
import Textarea from "../../../Components/Textarea";
import CustomRadio from "../../../Components/CustomRadio";
import TopBarNotConnected from "../../../Components/TopBarNotConnected";

import { useToast } from "../../../Context/ToastContext";
import { useLoader } from "../../../Context/LoaderContext";

import "./SimulateurStep1NotConnected.scss";
import Logo from "./../../../Images/logo_white.png";

const initialFormState = {
  product_name: "mobilier",
  amount: "",
  self_financing: "",
  taux: "9",
  duration: "36",
  description: "",
};

const SimulateurStep1NotConnected = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);

  const [formErrorMessages, setFormErrorMessages] = React.useState("");
  const [openModal, setOpenModal] = React.useState(false);
  const [resultAmount, setResultAmount] = React.useState();
  const [maxDelay, setmaxDelay] = React.useState(60);
  const [amountValue, setAmountValue] = React.useState(false);
  const [settings, setSettings] = React.useState([]);

  const navigate = useNavigate();
  const { id } = useParams();
  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const maxYear = 120;
  const minYear = 60;
  const minTaux = parseInt(settings.property_rate);
  const maxTaux = parseInt(settings.auto_rate);
  const step = 2;

  React.useEffect(() => {
    localStorage.removeItem(
      process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
    );
  }, []);

  const handleChangeField = (e, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    let newValueDuree = e.target.value;

    if (key === "duration" && +newValueDuree > maxDelay) {
      newValueDuree = maxDelay;
    }
    if (key === "taux" && +newValueDuree > maxTaux) {
      newValueDuree = maxTaux;
    }

    if (key === "product_name") {
      if (e.target.value === "mobilier") {
        setmaxDelay(minYear);
      } else {
        setmaxDelay(maxYear);
      }
    }

    if (key === "amount") {
      let maxAmount = e.target.value;
      if (maxAmount > 1000000) {
        setAmountValue(true);
      } else {
        setAmountValue(false);
      }
    }

    setValRegister((prev) => ({
      ...prev,
      [key]: newValueDuree,
    }));
  };

  // React.useEffect(() => {
  //   setIsLoading(true);

  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/simulation/${id}/show`)
  //     .then((response) => {
  //       setIsLoading(false);
  //       setValRegister(response.data.data.simulation || []);
  //     })
  //     .catch(() => {
  //       setIsLoading(false);
  //     });

  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/settings`)
  //     .then((response) => {
  //       setIsLoading(false);
  //       setSettings(response.data.data || []);
  //     })
  //     .catch(() => {
  //       setIsLoading(false);
  //     });
  // }, [id, setIsLoading]);

  const handleSimulationStep1 = (e) => {
    e.preventDefault();

    if (amountValue) {
      setOpenModal(false);
    } else {
      setOpenModal(true);
    }

    axios
      .post(`${process.env.REACT_APP_API_URL}/simulation/calcule`, {
        product_name: valRegister.product_name,
        amount: valRegister.amount,
        self_financing: valRegister.self_financing,
        taux: valRegister.taux,
        duration: valRegister.duration,
      })
      .then((response) => {
        setIsLoading(false);
        setResultAmount(response.data.data.amount);
      })
      .catch((error) => {
        setResultAmount("");
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}/simulation/store`, {
        product_name: valRegister.product_name,
        amount: valRegister.amount,
        self_financing: valRegister.self_financing,
        taux: valRegister.taux,
        duration: valRegister.duration,
        description: valRegister.description,
      })

      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          const accessToken = response.data.data.simulation.temporary_token;
          localStorage.setItem(
            process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE,
            accessToken
          );

          navigate(`/customer-information`);

          addToast({
            variant: "success",
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setOpenModal(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const generateMarksTaux = (minTaux, maxTaux) => {
    let marksTaux2 = [];

    for (let value = minTaux; value <= maxTaux; value += step) {
      marksTaux2.push({
        value: value,
        label: `${value}`,
      });
    }

    if (
      marksTaux2.lenght > 0 &&
      marksTaux2[marksTaux2.length - 1].value !== maxTaux
    ) {
      marksTaux2.push({
        value: maxTaux,
        label: `${maxTaux} %`,
      });
    }

    return marksTaux2;
  };

  const marksTaux = generateMarksTaux(minTaux, maxTaux);

  const marks =
    maxDelay === maxYear
      ? [
          {
            value: 10,
            label: "10",
          },
          {
            value: 20,
            label: "20",
          },
          {
            value: 30,
            label: "30",
          },
          {
            value: 40,
            label: "40",
          },
          {
            value: 50,
            label: "50",
          },
          {
            value: 60,
            label: "60",
          },
          {
            value: 70,
            label: "70",
          },
          {
            value: 80,
            label: "80",
          },
          {
            value: 90,
            label: "90",
          },
          {
            value: 100,
            label: "100",
          },
          {
            value: 110,
            label: "110",
          },

          {
            value: maxDelay,
            label: `${maxDelay}`,
          },
        ]
      : [
          {
            value: 10,
            label: "10",
          },
          {
            value: 20,
            label: "20",
          },
          {
            value: 30,
            label: "30",
          },
          {
            value: 40,
            label: "40",
          },
          {
            value: 50,
            label: "50",
          },
          {
            value: maxDelay,
            label: `${maxDelay}`,
          },
        ];

  return (
    <div className="layout-app layout-not-connected ">
      <div className="sideBar sideBar-not-connected">
        <Link to="/" className="logo logo-white">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
        <div className="title-sidebar-not-connected active">
          Lancez votre projet Leasing
        </div>
        <div className="menu-sidebar-not-connected active">
          <RiCalculatorLine /> Simulations
        </div>
        <div className="menu-sidebar-not-connected">
          <RiFileEditLine /> Demande de Financement
        </div>
      </div>
      <div className="wrap-app">
        <TopBarNotConnected
          backTo
          url="/"
          title="Détails du Projet de Leasing"
          description="Décrivez le bien que vous souhaitez financer par leasing ainsi que les conditions souhaitées."
        />
        <div className="container-app container-app-not-connected">
          <div className="step-simulateur">
            <form
              className="register-form"
              onSubmit={handleSimulationStep1}
              noValidate
            >
              <label htmlFor="product_name" className="bold d-block mb-2">
                Type de bien à financer
              </label>
              <div
                className={` mb-2 wrap-radios ${
                  formErrorMessages.product_name ? "error-radio" : ""
                }`}
              >
                <CustomRadio
                  label="Mobilier"
                  id="mobilier"
                  icone={<RiCarLine />}
                  name="product_name"
                  value="mobilier"
                  onChange={(e) => {
                    if (e.target.checked) handleChangeField(e, "product_name");
                  }}
                  checked={valRegister.product_name === "mobilier"}
                />

                <CustomRadio
                  label="Immobilier"
                  id="immobilier"
                  icone={<RiHomeOfficeLine />}
                  name="product_name"
                  value="immobilier"
                  onChange={(e) => {
                    if (e.target.checked) handleChangeField(e, "product_name");
                  }}
                  checked={valRegister.product_name === "immobilier"}
                />
                {formErrorMessages.product_name && (
                  <div className="text-danger">
                    {formErrorMessages.product_name}
                  </div>
                )}
              </div>
              {/* <Select
                label="Type de bien à financer"
                id="product_name"
                value={valRegister.product_name || ""}
                onChange={(e) => handleChangeField(e, "product_name")}
                hasError={formErrorMessages.product_name}
                errorMessage={
                  <div className="text-danger">
                    {formErrorMessages.product_name}
                  </div>
                }
              >
                <option value=""></option>
                <option value="mobilier">Mobilier</option>
                <option value="immobilier">Immobilier</option>
              </Select> */}

              <Textfield
                autoComplete="off"
                label="Montant net en TTC"
                name="amount"
                type="number"
                placeholder="Veuillez insérer votre montant"
                size="large"
                min={0}
                max={1000000}
                value={valRegister.amount}
                onChange={(e) => handleChangeField(e, "amount")}
                onKeyDown={(e) => {
                  if (
                    e.key === "e" ||
                    e.key === "+" ||
                    e.key === "-" ||
                    e.key === "."
                  ) {
                    e.preventDefault();
                  }
                }}
                hasError={formErrorMessages.amount}
                errorMessage={
                  formErrorMessages.amount &&
                  formErrorMessages.amount < 0 && (
                    <>
                      <div className="text-danger">
                        {formErrorMessages.amount}
                      </div>
                    </>
                  )
                }
              />
              {amountValue && (
                <div
                  className="text-danger"
                  style={{ position: "relative", top: "-10px" }}
                >
                  Merci d'insérer une valeur inférieure ou égale à 1 milliard.
                </div>
              )}
              {formErrorMessages.amount && formErrorMessages.amount < 0 && (
                <div className="text-danger">{formErrorMessages.amount}</div>
              )}
              <Textfield
                autoComplete="off"
                label="Autofinancement en TTC"
                name="self_financing"
                type="number"
                placeholder="Veuillez insérer votre autofinancement"
                size="large"
                min={0}
                max={1000000}
                value={valRegister.self_financing}
                onChange={(e) => handleChangeField(e, "self_financing")}
                onKeyDown={(e) => {
                  if (
                    e.key === "e" ||
                    e.key === "+" ||
                    e.key === "-" ||
                    e.key === "."
                  ) {
                    e.preventDefault();
                  }
                }}
                hasError={formErrorMessages.self_financing}
                errorMessage={
                  formErrorMessages.self_financing &&
                  formErrorMessages.self_financing < 0 && (
                    <>
                      <div className="text-danger">
                        {formErrorMessages.self_financing}
                      </div>
                    </>
                  )
                }
              />
              <div className="box-input textfield-large box-duration-simulation">
                <div className="wrap-field-duration">
                  <label className="bold" htmlFor="duration">
                    Durée (Mois)
                  </label>
                  <div className="group-input">
                    <input
                      autoComplete="off"
                      label="Durée"
                      name="duration"
                      id="duration"
                      type="number"
                      placeholder="Veuillez insérer votre duree"
                      size="large"
                      min={1}
                      max={maxDelay}
                      value={valRegister.duration}
                      onChange={(e) => handleChangeField(e, "duration")}
                      onKeyDown={(e) => {
                        if (
                          e.key === "e" ||
                          e.key === "+" ||
                          e.key === "-" ||
                          e.key === "."
                        ) {
                          e.preventDefault();
                        }
                      }}
                      // hasError={formErrorMessages.duration}
                      // errorMessage={
                      //   formErrorMessages.duration && (
                      //     <div className="text-danger">{formErrorMessages.duration}</div>
                      //   )
                      // }
                    />
                    {formErrorMessages.duration && (
                      <div className="text-danger">
                        {formErrorMessages.duration}
                      </div>
                    )}
                  </div>
                </div>
                <Slider
                  aria-label="Always visible"
                  value={+valRegister.duration}
                  min={1}
                  max={maxDelay}
                  valueLabelDisplay="on"
                  onChange={(e) => handleChangeField(e, "duration")}
                  // getAriaValueText={valuetext}
                  marks={marks}
                />
              </div>

              <Textarea
                autoComplete="off"
                label="Description"
                name="description"
                type="text"
                placeholder="Veuillez insérer votre description"
                size="large"
                value={valRegister.description}
                onChange={(e) => handleChangeField(e, "description")}
                hasError={formErrorMessages.description}
                errorMessage={
                  formErrorMessages.description && (
                    <div className="text-danger">
                      {formErrorMessages.description}
                    </div>
                  )
                }
              />

              <div className="wrap_actions_form">
                <Button
                  type="submit"
                  size="lg"
                  disabled={valRegister.amount === ""}
                >
                  Simuler
                </Button>
              </div>
            </form>

            <Modal
              isOpen={openModal}
              // isDismissible={true}
              onClose={handleClose}
              withCloseButton
              title="Résultat de la simulation"
              className="custom-modal-simulation"
            >
              <div className="caption-result-simulation">
                <span className="icon-simulation icon-loyer-simulation">
                  <RiCalendar2Line />
                </span>
                <span className="bold">Montant du loyer par mois en TTC: </span>
                <div className="item-montant">{resultAmount ? `${resultAmount} TND` : ""}</div>
                <p>Le taux appliqué au niveau du site est à titre indicatif</p>
              </div>

              <div className="wrap-result-simulation mb-24">
                <div className="caption-result-simulation">
                  <span className="icon-simulation icon-produit-simulation">
                    <RiHomeOfficeLine />
                  </span>
                  <span className="bold">Type de bien à financer: </span>
                  <div className="capitalize">{valRegister.product_name}</div>
                </div>
                <div className="caption-result-simulation">
                  <span className="icon-simulation icon-produit-simulation">
                    <RiMoneyDollarCircleLine />
                  </span>
                  <span className="bold">Autofinancement: </span>
                  <div className="capitalize">
                    {valRegister.self_financing} TND
                  </div>
                </div>

                <div className="caption-result-simulation">
                  <span className="icon-simulation icon-montant-simulation">
                    <RiMoneyDollarCircleLine />
                  </span>
                  <span className="bold">Montant: </span>
                  <div>{valRegister.amount} TND</div>
                </div>

                <div className="caption-result-simulation">
                  <span className="icon-simulation icon-montant-simulation">
                    <RiTimeLine />
                  </span>
                  <span className="bold">Durée: </span>
                  <div>{valRegister.duration} Mois</div>
                </div>
              </div>
              {valRegister.description && (
                <div className="mb-16 description-simulation">
                  <span className="bold">Description: </span>
                  <div>{valRegister.description}</div>
                </div>
              )}
              <div className="text-center">
                <Button type="submit" size="lg" onClick={handleSubmit}>
                  Enregistrer votre simulation
                </Button>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimulateurStep1NotConnected;
